import { createSlice } from '@reduxjs/toolkit';
import { getHiddenData, parseDocumentIDs } from '../domain/compare-bundles-provider';
import { ICompareBundlesData } from '../interfaces';

interface IState{
    documentIDs: number[];
    data: ICompareBundlesData|null;
    isMutualHidden: boolean;
}

/**
 * initial state
 */
const initialState: IState = {
    documentIDs: parseDocumentIDs(),
    data: getHiddenData(),
    isMutualHidden: false,
};

const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {

        main(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },
    }
});

export default rootSlice;